// src/sim/npcs/adults/commentary.ts — P5 Plan 08 final state (Pitfall 1 cleanup).
//
// The hardcoded ADULT_COMMENTARY record has been deleted. Commentary pools
// live in the Cloudflare-KV-backed ContentBundle (or the build-baked
// DEFAULT_BUNDLE fallback), hydrated into src/sim/content/cache.ts at App
// boot (P5 Plan 06). getCommentary(tag) preserves its P4 signature — every
// pre-P5 consumer (tick emission, AdultBT commentary selection) reads
// through the cache.
//
// History:
//   - P4: hardcoded ADULT_COMMENTARY record (free-mixed EN/PT lines).
//   - P5 Plan 01: DEFAULT_BUNDLE.commentary mirrored ADULT_COMMENTARY
//     byte-for-byte (Pitfall 8 parity guard).
//   - P5 Plan 02: getCommentary body-swapped to read from the cache;
//     ADULT_COMMENTARY retained as the parity source.
//   - P5 Plan 08 (this file): ADULT_COMMENTARY + parity test retired.
//
// Source: .planning/phases/05-content-pipeline-characters-admin-cms/05-CONTEXT.md D-22/D-23;
//         05-RESEARCH.md Pitfall 1.

import { getContentBundle } from '../../content/cache';

import type { EventTag } from '../../../shared/types/events';

export function getCommentary(tag: EventTag): string[] {
  return getContentBundle().commentary[tag] ?? [];
}
